module.exports = __webpack_public_path__ + "fonts/lato-hairlineitalic-webfont.75bf8d2a.woff";